import axios from "axios";
import { useAuthStore } from "../store/auth/auth.store";

// Get the API URL from the environment
const API_URL = import.meta.env.VITE_API_URL;

// Create an axios instance for API requests
export const apiClient = axios.create({
    baseURL: API_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

// Add an interceptor to add the auth token to every request
apiClient.interceptors.request.use((config) => {
    const token = useAuthStore.getState().token;

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

// Add an interceptor to handle common errors
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle 401 Unauthorized errors (expired tokens, etc.)
        if (error.response?.status === 401) {
            // Redirect to login or refresh token logic
            window.location.href = "/auth";
        }

        return Promise.reject(error);
    },
);
